/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  FormButton,
  FormGroup,
  FormInput,
  FormTextRequire,
} from '@/components/Form'
import ImageOptimize from '@/components/ImageOptimize'
import ModalBranchExhibition from '@/components/Popup/ModalBranchExhibition'
import OriginPrice from '@/components/Price/OriginPrice'
import SalePrice from '@/components/Price/SalePrice'
import { Languages, PageType, ProductStockStatus } from '@/constants'
import { useCart } from '@/containers'
import { IconCheckedSuccess } from '@/styles/Icon'
import type {
  GiftItems,
  OrderService,
  OtherOffers,
  Product,
  ProductCompare,
  ProductDetail,
} from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { translateSchema } from '@/utils/validations'
import { Dialog, Transition } from '@headlessui/react'
import clsx from 'clsx'
import { Form, Formik } from 'formik'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import {
  Fragment,
  useMemo,
  useState,
  type Dispatch,
  type SetStateAction,
} from 'react'
import { toast } from 'react-toastify'
import { Autoplay, FreeMode, Grid } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import AccompaniedService from '../AccompaniedService'
import Gift from '../Gift'
interface Props {
  entrySummaryData: ProductDetail
  checkSaleArea: boolean
  isOpenContact?: boolean
  setListService: Dispatch<SetStateAction<OrderService[]>>
  setIsOpenContact: Dispatch<SetStateAction<boolean>>
  setIsOpenComparePopup: Dispatch<SetStateAction<boolean>>
  listService?: OrderService[]
  setProductCompares: (newValue: ProductCompare[]) => void
  setListGift: Dispatch<SetStateAction<GiftItems[] | undefined>>
  listGift?: GiftItems[] | undefined
  setListOffer: Dispatch<SetStateAction<OtherOffers[] | undefined>>
  listOffer?: OtherOffers[] | undefined
  productCompares: ProductCompare[]
  pickUpInStore: boolean
  setPickUpInStore: Dispatch<SetStateAction<boolean>>
  priceWithService: number
  setPriceWithService: Dispatch<SetStateAction<number>>
  isOutOfStock: boolean
  handleInstallment: (
    product: Product | ProductDetail,
    type: string
  ) => Promise<any>
  cartLoading: boolean
  isPreOrder: boolean
  addToCartData: ProductDetail
  setIsOpenAddToCart?: Dispatch<SetStateAction<boolean>>
  handleAddBundleToCart: (product: any, type: string) => Promise<any>
  handleAddToCart: (
    product: Product | ProductDetail,
    type: string
  ) => Promise<any>
  listBundleSelected: Product[]
}
const EntrySummary = ({
  entrySummaryData,
  isOpenContact,
  setIsOpenContact,
  setListService,
  listService,
  setListGift,
  listGift,
  setListOffer,
  listOffer,
  setPickUpInStore,
  pickUpInStore,

  priceWithService,
  setPriceWithService,
}: Props) => {
  const t = useTranslations('ProductDetail')
  const { sendContact, isPreOrder } = useCart()

  const [isOpenDraw, setIsOpenDraw] = useState(false)
  const stockStatus = useMemo(() => {
    if (entrySummaryData?.stockStatus && !entrySummaryData?.flashSale) {
      if (entrySummaryData.stockStatus === ProductStockStatus.ARRIVING) {
        return ProductStockStatus.IN_STOCK
      }
      return entrySummaryData?.stockStatus
    }
    return ProductStockStatus.IN_STOCK
  }, [entrySummaryData])

  const percent = Math.ceil(
    100 - (entrySummaryData?.finalPrice / entrySummaryData?.price) * 100
  )

  const discountAmount = entrySummaryData?.price - entrySummaryData?.finalPrice
  const discountPercent =
    ((entrySummaryData?.price - entrySummaryData?.finalPrice) /
      entrySummaryData?.price) *
    100

  return (
    <div className='entry-main w-full'>
      <div className='entry-title bg-white px-2 py-2'>
        <div className='relative rounded-lg bg-pink-100 px-2 py-4'>
          {discountPercent >= 30 ? (
            <div className='absolute bottom-3 right-2 z-10 w-max min-w-[140px] overflow-hidden rounded-lg bg-[url(/assets/images/bg-label-1.png)] bg-cover bg-no-repeat'>
              <div className='content flex flex-col px-3 py-2 leading-tight'>
                <span className='mb-1 text-sm italic text-white'>
                  Tiết kiệm
                </span>
                <span className='text-base font-bold text-yellow-500'>
                  {discountAmount &&
                    discountAmount
                      .toLocaleString(Languages.VN, {
                        style: 'currency',
                        currency: 'VND',
                      })
                      .replace(/\s₫/g, 'đ')}
                </span>
              </div>
            </div>
          ) : (
            ''
          )}
          <p className='label mb-1.5 text-sm font-medium text-dark-900'>
            Mua ngay với giá
          </p>
          <SalePrice
            finalPrice={entrySummaryData?.finalPrice}
            classes={'text-3xl font-bold leading-tight text-primary-base'}
            type={PageType.PRODUCT}
          />
          <div className='flex items-center justify-start gap-x-2'>
            <OriginPrice
              type={PageType.PRODUCT}
              originPrice={entrySummaryData?.price}
              classes='!text-base !text-black-100 leading-tight line-through'
            />
            {percent > 0 && (
              <span className='discount flex items-center gap-[2px]'>
                <span className='flex h-5 items-center rounded bg-pink-300/20 px-1 text-percent text-sm font-semibold text-primary-base'>
                  <span className='value'>-{percent}</span>
                  <span className='unit'>%</span>
                </span>
              </span>
            )}
          </div>
        </div>

        {listService &&
        ![
          ProductStockStatus.OUT_OF_STOCK,
          ProductStockStatus.OUT_OF_BUSINESS,
        ].includes(stockStatus as ProductStockStatus) &&
        listService.length ? (
          <AccompaniedService
            setListService={setListService}
            productId={entrySummaryData?._id}
            productPrice={entrySummaryData?.finalPrice}
            listService={listService}
            pickUpInStore={pickUpInStore}
            setPickUpInStore={setPickUpInStore}
            receiveAtWarehouse={entrySummaryData?.receiveAtWarehouse}
            preOrderPrice={entrySummaryData?.preOrder?.salePrice}
            isPreOrder={isPreOrder}
            priceWithService={priceWithService}
            setPriceWithService={setPriceWithService}
          />
        ) : (
          ''
        )}
      </div>
      {![
        ProductStockStatus.OUT_OF_STOCK,
        ProductStockStatus.OUT_OF_BUSINESS,
      ].includes(stockStatus as ProductStockStatus) && listGift ? (
        <div className='entry-price border-b-8 border-gray-200'>
          <div className='priceNotLogin rounded-lg border-b-[1px] border-gray-200 bg-red-500 pt-4'>
            <h2 className='mb-2 ml-[14px] pb-1 text-left text-titleSection font-bold text-white'>
              Khuyến mãi kèm theo
            </h2>
            <Gift
              setListGift={setListGift}
              listGift={listGift}
              setListOffer={setListOffer}
              listOffer={listOffer}
              login={true}
            />
          </div>
        </div>
      ) : (
        ''
      )}
      {entrySummaryData?.otherInfos && (
        <div className='entry-addOtherInfo border-b-8 border-gray-200'>
          <div className=' w-full rounded-lg bg-zinc-300 px-[5px] py-2'>
            <ul className='flex w-full flex-wrap gap-1.5'>
              {entrySummaryData?.otherInfos?.map((item, idx) => {
                return (
                  <li
                    className='item flex w-full items-start rounded-md bg-white px-2 py-2.5'
                    key={idx}
                  >
                    <Image
                      src={'/assets/icons/list.svg'}
                      width={20}
                      height={20}
                      alt='icon'
                      className='max-w-[20px] flex-[0_0_20px]'
                    />
                    <div className='text flex-auto pl-2'>
                      <span className='text-sm font-normal leading-normal text-gray-800'>
                        {getTranslate(item?.name)}
                      </span>{' '}
                      {item?.link && (
                        <Link
                          className='whitespace-nowrap text-xs font-normal text-blue'
                          href={item?.link || ''}
                        >
                          (Chi tiết)
                        </Link>
                      )}
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      )}
      {entrySummaryData?.banners ? (
        <div className='w-full pb-2'>
          {entrySummaryData?.banners.length > 1 ? (
            <>
              <Swiper
                modules={[Grid, FreeMode, Autoplay]}
                className='!mx-[6px] overflow-hidden rounded-lg'
                slidesPerView={1}
                loop={true}
                spaceBetween={10}
                autoplay={{
                  delay: 3500,
                  disableOnInteraction: false,
                  stopOnLastSlide: true,
                }}
                speed={700}
              >
                {entrySummaryData?.banners?.map((item, idx) => (
                  <SwiperSlide key={'key' + idx}>
                    <Link
                      href={item?.link || ''}
                      className='block w-full cursor-pointer overflow-hidden rounded-lg'
                    >
                      <ImageOptimize
                        src={item?.image || ''}
                        alt={item?.title || ''}
                        className='w-full'
                      />
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            </>
          ) : (
            <Link
              href={entrySummaryData?.banners[0]?.link || ''}
              className='block w-full cursor-pointer px-[6px]'
            >
              <ImageOptimize
                src={entrySummaryData?.banners[0]?.image}
                alt={entrySummaryData?.banners[0]?.title}
                className='w-full overflow-hidden rounded-lg'
              />
            </Link>
          )}
        </div>
      ) : (
        ''
      )}
      {/* Popup choose store */}
      <ModalBranchExhibition
        isOpen={isOpenDraw}
        setIsOpen={setIsOpenDraw}
        productId={entrySummaryData?._id}
      />
      <Transition appear show={isOpenContact} as={Fragment}>
        <Dialog
          as='div'
          onClose={() => {
            setIsOpenContact(false)
          }}
          className='relative z-[9999]'
        >
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-200'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bottom-0 left-0 z-[9999] bg-dark-900/60 transition-opacity' />
          </Transition.Child>
          <div className='fixed inset-0 z-[9999] overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center p-4 text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-200'
                enterFrom='opacity-0 scale-50'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-50'
              >
                <Dialog.Panel className='w-full max-w-[400px] transform overflow-hidden rounded-lg bg-white px-2 py-4 text-left align-middle transition-all'>
                  <h3 className='mb-6 mt-3 text-center text-base font-bold uppercase text-dark-900'>
                    Gọi lại cho tôi
                  </h3>
                  {
                    <div
                      onClick={() => {
                        setIsOpenContact(false)
                      }}
                      className='absolute right-1 top-2 flex cursor-pointer items-center gap-1'
                    >
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 51 50'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <circle cx='25.5957' cy='25' r='25' fill='black' />
                        <g clip-path='url(#clip0_19560_66822)'>
                          <path
                            d='M31.8226 34.3527L25.5957 28.1257L19.3688 34.3527C18.5056 35.2158 17.1062 35.2158 16.243 34.3527C15.3799 33.4895 15.3799 32.0901 16.243 31.2269L22.47 25L16.243 18.7731C15.3799 17.9099 15.3799 16.5105 16.243 15.6473C17.1062 14.7842 18.5056 14.7842 19.3688 15.6473L25.5957 21.8743L31.8226 15.6473C32.6858 14.7842 34.0852 14.7842 34.9484 15.6473C35.8115 16.5105 35.8115 17.9099 34.9484 18.7731L28.7214 25L34.9484 31.2269C35.8115 32.0901 35.8115 33.4895 34.9484 34.3527C34.0852 35.2158 32.6858 35.2158 31.8226 34.3527Z'
                            fill='white'
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0_19560_66822'>
                            <rect
                              width='20'
                              height='20'
                              fill='white'
                              transform='translate(15.5957 15)'
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  }
                  <div className='listLocation border-grey-100 flex h-full flex-col items-center justify-center overflow-scroll px-1 scrollbar-hide'>
                    <Formik
                      initialValues={{
                        phone: '',
                        name: '',
                      }}
                      validationSchema={translateSchema('contact', t)}
                      onSubmit={async values => {
                        await sendContact({
                          ...values,
                          productIds: [entrySummaryData?._id],
                        }).then(() => {
                          toast.success('Gửi yêu cầu thành công', {
                            position: 'bottom-center',
                            icon: <IconCheckedSuccess />,
                            autoClose: 1500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                            theme: 'dark',
                          })
                        })
                        setIsOpenContact(false)
                        return
                      }}
                    >
                      {props => (
                        <Form onSubmit={props.handleSubmit}>
                          <p className='text-sm italic leading-snug text-dark-900'>
                            Vui lòng nhập các thông tin phía dưới để dienmaykho
                            có thể liên hệ, tư vấn cho quý khách hàng một cách
                            nhanh chóng và thuận tiện nhất.
                          </p>
                          <div className='mt-[20px]'>
                            <FormGroup className='mb-5 flex w-full flex-col'>
                              <span className='mb-1.5 text-sm font-semibold text-dark-900'>
                                Họ và tên
                              </span>
                              <FormInput
                                name='name'
                                placeholder='Nhập họ và tên'
                                value={props.values.name}
                                onChange={props.handleChange}
                                alert
                                className={clsx(
                                  props.errors.name && 'border border-orange',
                                  'rounded border border-border-500 text-sm transition placeholder:text-sm hover:cursor-pointer focus:border-blue disabled:bg-gray-200  disabled:text-dark-400/50'
                                )}
                              ></FormInput>
                              {props.errors.name && (
                                <FormTextRequire className=' text-sm font-normal text-primary-base'>
                                  {props.errors.name as string}
                                </FormTextRequire>
                              )}
                            </FormGroup>
                            <FormGroup className='mb-5 flex w-full flex-col'>
                              <span className='mb-1 text-sm font-semibold text-dark-900'>
                                Số điện thoại
                              </span>
                              <FormInput
                                name='phone'
                                placeholder='Nhập số điện thoại'
                                value={props.values.phone}
                                onChange={e => {
                                  props.handleChange({
                                    target: {
                                      value: e.target.value
                                        .trim()
                                        .replace(/\D/, ''),
                                      name: 'phone',
                                    },
                                  })
                                }}
                                alert
                                className={`rounded border border-border-500 text-sm transition placeholder:text-sm hover:cursor-pointer focus:border-blue disabled:bg-gray-200  disabled:text-dark-400/50`}
                              />
                              {props.errors.phone && (
                                <FormTextRequire className=' text-sm font-normal text-primary-base'>
                                  {props.errors.phone as string}
                                </FormTextRequire>
                              )}
                            </FormGroup>
                            <FormButton
                              className={`h-12 w-full overflow-hidden rounded-lg bg-primary-base text-sm font-semibold uppercase text-white outline-none`}
                            >
                              Xác nhận
                            </FormButton>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  )
}
export default EntrySummary
